<template>
    <div>
        <img class="main-bg" src="@/assets/img/main-bg.jpg" fit="cover"></img>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"

export default {
    mixins: [verifyMixin],
    data: function () {
        return {

        }
    },
    methods: {

    }
}
</script>
<style scoped lang="less">
    .main-bg {
        width: calc(100% - 24px);
        display: block;
        margin: 0px auto;
        height: calc(100vh - 140px);
        object-fit: fill;
    }
</style>